import React, { useState, useEffect, useMemo } from "react";
import { FaUserClock } from "react-icons/fa";
import { FaUserEdit } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { FaUserLock } from "react-icons/fa6";
import { FaUserCheck } from "react-icons/fa6";
import { GiReceiveMoney } from "react-icons/gi";
import { GrMoney } from "react-icons/gr";
import { FaMoneyCheck } from "react-icons/fa";
import { FaDollarSign } from "react-icons/fa";
import { BsPersonFillGear } from "react-icons/bs";
import { BsPersonFillUp } from "react-icons/bs";
import { MdPersonOff } from "react-icons/md";
import { BsPersonFillDash } from "react-icons/bs";
import { BsPersonVcardFill } from "react-icons/bs";
import { RiTeamFill } from "react-icons/ri";
import { FaUserTag } from "react-icons/fa6";
import { FaUserTimes } from "react-icons/fa";
import "./styles.scss";
import DashboardService from "../../services/Dashboard.services";
import localStorageContent from "../../utils/localstorage";
import Skeleton from "../../components/Skeletons";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import DepartmentService from "../../services/Departments.services";
import TeamLeadService from "../../services/TeamLead.services";
import { Col, DatePicker, Row, Select } from "antd";
import { useDispatch } from "react-redux";
import { setError } from "../../store/reducers";
import TeamService from "../../services/Team.services";
import { gutterBlobal } from "../Leads/Lead/constants";
import { getWeekDates, departmentOptions } from "./constants";
import LeadService from "../../services/Lead.services";
import { Table, Button, Modal, Spin, message } from "antd";
import { useNavigate } from "react-router-dom";
const { RangePicker } = DatePicker;
const currentYear = new Date().getFullYear(); // 2025
const lastSixYearsOptions = Array.from({ length: 9 }, (_, i) => {
  const year = currentYear - i; // Start from the previous year
  return { value: String(year), label: String(year) };
});

const Dashboard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState<any>(null);
  const [leadDetails, setLeadDetails] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [leadsData, setLeadsData] = useState<null | any>(null);
  const [itrYear, setItrYear] = useState<string | undefined>(undefined);
  const [processCurrentPage, setProcessCurrentPage] = useState<number>(1);
  const [financeCurrentPage, setFinanceCurrentPage] = useState<number>(1);
  const [processData, setProcessData] = useState<any[]>([]);
  const [financeData, setFinanceData] = useState<any[]>([]);
  const [animationActive, setAnimationActive] = useState(true);
  const [paymentsData, setPaymentsData] = useState<null | any>(null);
  const [ticketsData, setTicketsData] = useState<null | any>(null);

  const [salesData, setSalesData] = useState<null | any>(null);
  const [dateRangeValue, setDateRangeValue] = useState<any>([]);
  const [teamList, setTeamList] = useState<any[]>([]);
  const [dateFilter, setDateFilter] = useState<any>("");
  const [leadList, setLeadList] = useState<any[]>([]);
  const [digitalQueryString, setDigitalQueryString] = useState<any>("");
  const [teamFilter, setTeamFilter] = useState<any>(null);
  const [itrFilter, setItrFilter] = useState<any>(null);

  const userData = localStorageContent.getUserData();
  const multiDep = localStorageContent.getMultiDepartment();
  const dispatch = useDispatch();
  const { getDashboardDetails, getDashboardLeadwiseWiseteammembersDetails } =
    DashboardService;
  const { getTeamList, getTeam, filterTeamLeadByDept } = TeamService;
  const { getleadList } = LeadService;
  const { getTeamLeadList, getTeamLead, getTeamLeadSearchDropdownList } =
    TeamLeadService;
  const itemsPerPage = 150;
  const localUserData = localStorageContent.getUserData();
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [error, setErrorState] = useState<string | null>(null);
  const [isTeamDropdownDisabled, setIsTeamDropdownDisabled] = useState(true); // Initially disabled
  const { getDepartmentList } = DepartmentService;
  const [departmentList, setDepartmentList] = useState<any[]>([]);
  const [teamLeadList, setTeamLeadList] = useState<any[]>([]);

  const cards = [
    {
      title: "Process Leads",
      Icon: FaUserClock,
      count: 100,
      keys: ["processLeads"],
    },
    {
      title: "Preparation Leads",
      Icon: FaUserEdit,
      count: 10,
      keys: ["verificationLeads"],
    },
    {
      title: "Review Leads",
      Icon: FaUserEdit,
      count: 10,
      keys: ["reviewLeads"],
    },
    {
      title: "Total Leads",
      Icon: FaUsers,
      count: 40,
      keys: ["totalLeads"],
    },
    {
      title: "Submission Leads",
      Icon: FaUserLock,
      count: 80,
      keys: ["submissionLeads"],
    },
    {
      title: "Finance Leads",
      Icon: FaUserLock,
      count: 80,
      keys: ["processPayments"],
    },
    {
      title: "Completed Leads",
      Icon: FaUserCheck,
      count: 105,
      keys: ["completedLeads"],
    },
    {
      title: "Open Contacts",
      Icon: BsPersonFillGear,
      count: 105,
      keys: ["openContacts"],
    },
    {
      title: "Closed Contacts",
      Icon: FaUserTimes,
      count: 105,
      keys: ["closedContacts"],
    },
    {
      title: "Pending",
      Icon: BsPersonVcardFill,
      count: 105,
      keys: ["pending"],
    },
    {
      title: "Total",
      Icon: RiTeamFill,
      count: 100,
      keys: ["total"],
    },
    {
      title: "Open Leads",
      Icon: BsPersonFillGear,
      count: 105,
      keys: ["openLeads"],
    },
    {
      title: "Closed Leads",
      Icon: FaUserCheck,
      count: 105,
      keys: ["closedLeads"],
    },
    {
      title: "ReOpen Leads",
      Icon: FaUserCheck,
      count: 155,
      keys: ["reOpenLeads"],
    },
    {
      title: "Walkout Leads",
      Icon: FaUserCheck,
      count: 105,
      keys: ["walkoutLeads"],
    },
    {
      title: "Received Fee",
      Icon: GiReceiveMoney,
      count: 100,
      keys: ["ReceivedAmount"],
    },
    {
      title: "Actual Fee",
      Icon: GrMoney,
      count: 101,
      keys: ["TotalAmount"],
    },
    {
      title: "Variance",
      Icon: FaMoneyCheck,
      count: 40,
      keys: ["pendingAmount"],
    },
    {
      title: "Average",
      Icon: FaMoneyCheck,
      count: 40,
      keys: ["Average"],
    },
    {
      title: "VTF Received Fee",
      Icon: FaMoneyCheck,
      count: 40,
      keys: ["ctfReceivedAmount"],
    },
    {
      title: "Follow Up",
      Icon: FaUserTag,
      count: 105,
      keys: ["followup"],
    },
    {
      title: "Interested",
      Icon: BsPersonFillUp,
      count: 100,
      keys: ["interested"],
    },
    {
      title: "Not Interested",
      Icon: MdPersonOff,
      count: 10,
      keys: ["notInterested"],
    },
    {
      title: "Voicemail",
      Icon: BsPersonFillDash,
      count: 40,
      keys: ["voicemail"],
    },
    {
      title: "Invalid Number",
      Icon: BsPersonFillDash,
      count: 40,
      keys: ["invalidNumber"],
    },
    {
      title: "Not InService",
      Icon: BsPersonFillDash,
      count: 40,
      keys: ["notInService"],
    },
    {
      title: "DND",
      Icon: BsPersonFillDash,
      count: 40,
      keys: ["dnd"],
    },
    {
      title: "Citizens",
      Icon: BsPersonFillDash,
      count: 40,
      keys: ["citizens"],
    },
    {
      title: "Closed  tickets",
      Icon: BsPersonFillDash,
      count: 40,
      keys: ["closedTicket"],
    },
    {
      title: "Pending tickets",
      Icon: BsPersonFillDash,
      count: 40,
      keys: ["pendingTickets"],
    },
    {
      title: "Processing tickets",
      Icon: BsPersonFillDash,
      count: 40,
      keys: ["processingTickets"],
    },
  ];

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedLead(null);
  };

  const columns = [
    {
      title: "Lead ID",
      dataIndex: "lead_id",
      key: "lead_id",
    },
    {
      title: "Associate Name",
      dataIndex: "associate_name",
      key: "associate_name",
      render: (_: any, record: any) => `${record.team_names}`,
    },
    {
      title: "Client Name",
      dataIndex: "client_name", // assuming client name same as associate name; adjust if API has separate client
      key: "client_name",
      render: (_: any, record: any) =>
        `${record.first_name} ${record.last_name}`,
    },
    {
      title: "Actual Charge",
      dataIndex: "actual_amount", // assuming client name same as associate name; adjust if API has separate client
      key: "actual_amount",
      render: (_: any, record: any) => `${record.actual_amount ?? "0.00"}`,
    },
    {
      title: "Serivce Charge",
      dataIndex: "service_charge", // assuming client name same as associate name; adjust if API has separate client
      key: "service_charge",
      render: (_: any, record: any) => `${record.service_charge ?? "0.00"} `,
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Button
          type="primary"
          onClick={() => navigate(`/leads/edit/${record.lead_id}`)}
        >
          View
        </Button>
      ),
    },
  ];

  // Data for the table (filter by selected lead)
  const tableData = selectedLead
    ? leadDetails.filter((lead: any) => lead.leadKey === selectedLead.key)
    : [];

  const handleCardClick = async (leadKey: string, leadInfo: any) => {
    setSelectedLead({ key: leadKey, info: leadInfo });
    setIsModalOpen(true);
    setLoading(true);
    console.log("userData", userData);

    try {
      let apiUrl = "/dashboard/details";

      // 🔍 Append departmentId only if role is not "1"
      if (userData.role !== "1" && userData.departmentId) {
        apiUrl += `?deptId=${userData.departmentId}`;
      }

      // 🔥 Append dateFilter correctly using & or ?
      if (dateFilter) {
        apiUrl += apiUrl.includes("?") ? `&${dateFilter}` : `?${dateFilter}`;
      }

      const response = await DashboardService.getLeadDetails(apiUrl);
      const leadsData = response?.data?.leads || {};
      const selectedData = leadsData[leadKey] || [];

      setLeadDetails(selectedData);
    } catch (error) {
      console.error("Error fetching lead details:", error);
      message.error("Failed to fetch lead details");
    } finally {
      setLoading(false);
    }
  };

  // const handleCardClick = async (leadKey: string, leadInfo: any) => {
  //   setSelectedLead({ key: leadKey, info: leadInfo });
  //   setIsModalOpen(true);
  //   setLoading(true);

  //   try {
  //     let apiUrl = `/dashboard/details?type=${leadKey}`;
  //     if (dateFilter) apiUrl += `&${dateFilter}`; // ✅ use & instead of ?

  //     const response = await DashboardService.getLeadDetails(apiUrl);
  //     const leadsData = response?.data?.leads || {};
  //     const selectedData = leadsData[leadKey] || [];

  //     setLeadDetails(selectedData);
  //   } catch (error) {
  //     console.error("Error fetching lead details:", error);
  //     message.error("Failed to fetch lead details");
  //   } finally {
  //     setLoading(false); // ✅ properly closed
  //   }
  // };

  const fetchDepartmentList = async () => {
    try {
      setIsLoading(true);
      const response = await getDepartmentList();
      const { data } = response;
      if (data && data.length > 0) {
        setDepartmentList(
          data.map((dt: any) => ({
            value: dt.dept_id,
            label: dt.name,
          }))
        );
      }

      setIsLoading(false);
    } catch (err: any) {
      setIsLoading(false);
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  const fetchTeamLeadList = async (selected: any) => {
    try {
      setIsLoading(true);

      const response = await filterTeamLeadByDept({ departmentIds: selected });
      const { data } = response;

      if (data && data.length > 0) {
        const formattedData = data.map((dt: any) => ({
          value: dt.user_id,
          label: `${dt.first_name} ${dt.last_name}`,
        }));

        setTeamLeadList(formattedData);
      } else {
        setTeamLeadList([]);
      }

      setIsLoading(false);
    } catch (err: any) {
      setIsLoading(false);
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  const fetchTeamList = async (teamLeadId: any) => {
    try {
      if (!teamLeadId) return;

      setIsLoading(true);
      setIsTeamDropdownDisabled(true); // Disable until loaded

      const response = await getTeamList(
        `/team/search-teams?teamLeadId=${teamLeadId}`
      ); // 👈 Use teamLeadId here

      if (response && response.data && response.data.length > 0) {
        const formattedList = response.data.map((team: any) => ({
          label: `${team?.first_name} ${team?.last_name}`,
          value: team.user_id,
        }));
        setTeamList(formattedList);
        setDataLoaded(true);
        setIsTeamDropdownDisabled(false); // ✅ Enable after load
      } else {
        setTeamList([]);
        setDataLoaded(false);
        setIsTeamDropdownDisabled(true);
      }
    } catch (err: any) {
      setTeamList([]);
      setDataLoaded(false);
      setIsTeamDropdownDisabled(true);
      dispatch(
        setError({
          status: true,
          type: "error",
          message: err.message || "An error occurred while fetching team data",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    localUserData && localUserData?.role === "1" && fetchDepartmentList();
    if (
      localUserData &&
      localUserData.role !== "1" &&
      localUserData.role !== "3"
    ) {
      fetchTeamLeadList([localUserData?.departmentId]);
    }
    fetchTeamList(null);
  }, []);

  const onChangeData = (e: any, type: string) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);

    if (type === "RANGE") {
      setDateRangeValue(e);
      let dateQueryString: any = null;

      if (e && e.length === 2) {
        const start = dayjs(e[0]?.$d)
          .utc()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        const end = dayjs(e[1]?.$d)
          .utc()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");

        dateQueryString = `startDate=${start}&endDate=${end}`;
      }

      setFinanceCurrentPage(1);
      setProcessCurrentPage(1);
      setDateFilter(dateQueryString);
    }

    if (type === "ITR_YEAR") {
      setItrFilter(e);

      // Build query string and call API directly
      let queryString = "";
      if (dateFilter) queryString += dateFilter;
      if (e) queryString += (queryString ? "&" : "") + `itrYear=${e}`;
      if (teamFilter)
        queryString += (queryString ? "&" : "") + `teamId=${teamFilter}`;

      if (
        userData?.departmentId === 1 &&
        [2, 3, 5].includes(Number(userData.role))
      ) {
        getSalesDashboard(queryString);
      } else if (userData?.departmentId === 8) {
        getDigitalDashboard(queryString);
        setDigitalQueryString(queryString);
      } else {
        fetchDashboardDetails(queryString);
      }
    }

    if (type === "TEAM") {
      setTeamFilter(e);
    }
  };

  const fetchDashboardDetails = async (query: string) => {
    try {
      setIsLoading(true);
      let URL = "";
      if (multiDep !== null && multiDep && userData) {
        URL = query
          ? `/dashboard?deptId=${userData.departmentId}&${query}`
          : `/dashboard?deptId=${userData.departmentId}`;
      } else {
        URL = query ? `/dashboard?${query}` : "/dashboard";
      }

      // Add itrYear if it exists and is valid
      if (itrYear && itrYear.trim() !== "") {
        URL += URL.includes("?")
          ? `&itrYear=${itrYear}`
          : `?itrYear=${itrYear}`;
      }

      const response = await getDashboardDetails(URL);

      if (response && response.data) {
        const dashboard = response.data;
        setTicketsData(dashboard["tickets"] || []);
        setSalesData(dashboard["salesReports"] || []);
        setDataLoaded(true);

        const dashboardKeys = Object.keys(dashboard);
        if (dashboardKeys.length > 0) {
          dashboardKeys.forEach((key: any, index: any) => {
            if (index === 0) {
              setLeadsData(dashboard[key] || []);
            }
            if (index === 1) {
              setPaymentsData(dashboard[key] || []);
            }
          });
        }
      } else {
        // Handle case where response.data is undefined or empty
        setTicketsData([]);
        setSalesData([]);
        setLeadsData([]);
        setPaymentsData([]);
      }
    } catch (err: any) {
      setTicketsData([]);
      setSalesData([]);
      setLeadsData([]);
      setPaymentsData([]);
      dispatch(
        setError({
          status: true,
          type: "error",
          message:
            err.message || "An error occurred while fetching dashboard data.",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const getSalesDashboard = async (query: any) => {
    try {
      setIsLoading(true);
      let URL = query
        ? `/dashboard/sales-reports?${query}`
        : "/dashboard/sales-reports";
      const response = await getDashboardDetails(URL);
      if (response) {
        const dashboard = response?.data;
        setLeadsData(dashboard);
      }
      setIsLoading(false);
    } catch (err: any) {
      setIsLoading(false);
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  const getDigitalDashboard = async (query: any) => {
    try {
      setIsLoading(true);
      let URL = `/dashboard/agent-statistics?deptId=${userData.departmentId}`;
      const response = await getDashboardDetails(URL);
      setFinanceCurrentPage(1);
      setProcessCurrentPage(1);
      if (response) {
        const dashboard = response?.data;
        setLeadsData(dashboard);
      }
      setIsLoading(false);
    } catch (err: any) {
      setIsLoading(false);
      dispatch(setError({ status: true, type: "error", message: err }));
    }
  };

  const filterOption = useMemo(
    () => (input: string, option?: { label: string; value: string }) =>
      (option?.label ?? "").toLowerCase().includes(input.toLowerCase()),
    []
  );

  const getItemsForPage = (page: number, data: any) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return data.slice(startIndex, endIndex);
  };

  const LoadLeadTeamList = async (id: any) => {
    const response = await getDashboardLeadwiseWiseteammembersDetails(id);
    if (response && response?.data?.length > 0) {
      const teamMembers: any = [];
      response?.data?.map((team: any) => {
        teamMembers.push({
          label: `${team?.first_name} ${team?.last_name}`, // Combine first and last name
          value: team.user_id,
        });
      });
      setTeamList(teamMembers);
      setIsTeamDropdownDisabled(false); // Enable the team dropdown after successful load
    } else {
      setTeamList([]);
      setIsTeamDropdownDisabled(true); // Keep the dropdown disabled if no data
    }
  };

  useEffect(() => {
    if (userData?.role === "5" && userData?.userId) {
      LoadLeadTeamList(userData.userId);
    }
  }, []);

  const handelselect = (Id: any) => {
    fetchTeamLeadList([Id]); //
  };

  useEffect(() => {
    const searchObject: any = {
      date: dateFilter,
      teamId: teamFilter,
      itr: itrFilter,
    };

    const objKeys = Object.keys(searchObject);

    let queryString: string = "";
    objKeys.forEach((key: any) => {
      if (key === "date" && searchObject[key]) {
        queryString = searchObject[key];
      }
      if (key === "itr" && searchObject[key]) {
        queryString += queryString
          ? `&itrYear=${searchObject[key]}` // Append if queryString already has content
          : `itrYear=${searchObject[key]}`; // Start with itrYear if queryString is empty
      }
      if (
        (userData?.role === "1" ||
          userData?.role === "2" ||
          userData?.role === "5") &&
        key === "teamId" &&
        searchObject[key]
      ) {
        if (searchObject.date) {
          queryString = `${queryString + "&" + key + "=" + searchObject[key]}`;
        } else {
          queryString = `${key + "=" + searchObject[key]}`;
        }
      }
    });

    if (dateFilter !== "") {
      if (
        userData &&
        userData.departmentId === 1 &&
        (userData.role === "3" ||
          userData.role === "2" ||
          userData.role === "5")
      ) {
        getSalesDashboard(queryString);
      } else if (userData && userData.departmentId === 8) {
        getDigitalDashboard(queryString);
        setDigitalQueryString(queryString);
      } else {
        fetchDashboardDetails(queryString);
      }
    }
    //}, [teamFilter, dateFilter, itrFilter]);
  }, [teamFilter, dateFilter, itrFilter]);

  useEffect(() => {
    dayjs.extend(utc);
    dayjs.extend(timezone);

    const startDate = dayjs().utc().startOf("day"); // UTC Start of the day
    const endDate = dayjs().utc().endOf("day"); // UTC End of the day

    if ((userData && userData?.departmentId <= 8) || userData?.role === "1") {
      setDateFilter([startDate, endDate]);
      setDateRangeValue([startDate, endDate]);
    } else {
      setDateFilter("initial");
    }

    if (
      (userData?.role === "1" ||
        userData?.role === "2" ||
        userData?.role === "5") &&
      userData?.departmentId !== 8
    ) {
      if (!dataLoaded) {
        // fetchTeamList();
      }
    }
  }, []);

  useEffect(() => {
    let intervalId: any = null;

    if (leadsData && userData && userData.departmentId === 8) {
      const processData = getItemsForPage(
        processCurrentPage,
        leadsData?.processData?.length > 0 ? leadsData?.processData : []
      );
      const financeData = getItemsForPage(
        financeCurrentPage,
        leadsData?.financeData?.length > 0 ? leadsData?.financeData : []
      );
      setProcessData(
        processData.filter((process: any) => process.totalLeads >= 0)
      );
      setFinanceData(
        financeData.filter((finance: any) => finance.totalLeads >= 0)
      );

      intervalId = setInterval(() => {
        const maxData: any = [
          leadsData?.processData?.length,
          leadsData?.financeData?.length,
        ];
        const page =
          leadsData?.processData?.length > leadsData?.financeData?.length
            ? processCurrentPage
            : financeCurrentPage;
        if (page >= Math.ceil(Math.max(...maxData) / itemsPerPage)) {
          let timeout: any = null;
          timeout = setTimeout(() => {
            getDigitalDashboard(digitalQueryString);
            clearTimeout(timeout);
          }, 100);
        }
        if (leadsData?.financeData.length > itemsPerPage) {
          const financeCopyData =
            leadsData?.financeData?.length > 0 ? leadsData?.financeData : [];
          const financeData = getItemsForPage(
            financeCurrentPage,
            financeCopyData
          );
          setFinanceData(financeData);
          if (
            financeCurrentPage >=
            Math.ceil(financeCopyData.length / itemsPerPage)
          ) {
            setFinanceCurrentPage(1);
            return;
          }
        }

        if (leadsData?.processData.length > itemsPerPage) {
          const processCopyData =
            leadsData?.processData?.length > 0 ? leadsData?.processData : [];
          const processData = getItemsForPage(
            processCurrentPage,
            processCopyData
          );
          setFinanceData(processData);
          if (
            processCurrentPage >=
            Math.ceil(leadsData?.processData?.length / itemsPerPage)
          ) {
            setProcessCurrentPage(1);
            return;
          }
          setProcessCurrentPage(processCurrentPage + 1);
        }

        setAnimationActive(false);

        setTimeout(() => {
          setAnimationActive(true);
        }, 100);
      }, 15000);
    }
    return () => clearInterval(intervalId);
  }, [leadsData, processCurrentPage, financeCurrentPage]);

  return (
    <div className="dashboard-container">
      <div>
        <Row gutter={gutterBlobal}>
          {userData?.departmentId !== 8 && (
            <>
              {["1"].includes(userData?.role) && (
                <Select
                  placeholder="ITR Year"
                  defaultValue={String(dayjs().year())} // Preselect previous year
                  onChange={(e) => onChangeData(e, "ITR_YEAR")}
                >
                  {lastSixYearsOptions.map((option) => (
                    <Select.Option key={option.value} value={option.value}>
                      {option.label}
                    </Select.Option>
                  ))}
                </Select>
              )}
              <Col xl={6} sm={12} xs={24}>
                <RangePicker
                  picker={"date"}
                  value={dateRangeValue}
                  style={{ width: "100%" }}
                  onChange={(e: any) => onChangeData(e, "RANGE")}
                />
              </Col>
            </>
          )}

          {["1"].includes(userData?.role) &&
            ![8].includes(userData?.departmentId) && (
              <Col xl={4} sm={12} xs={24}>
                <Select
                  showSearch
                  options={departmentOptions}
                  style={{ width: "100%" }}
                  onChange={(value) => handelselect(value)} // value will be the selected department's value
                  placeholder={"Select Department LIst"}
                  filterOption={filterOption}
                  onClear={() => {
                    setTeamFilter(null);
                    setIsTeamDropdownDisabled(true); // Disable the team dropdown if lead is cleared
                  }}
                  allowClear
                />
              </Col>
            )}

          {["1", "2"].includes(userData?.role) &&
            ![8].includes(userData?.departmentId) && (
              <Col xl={6} sm={12} xs={24}>
                <Select
                  showSearch
                  options={teamLeadList} // 👈 use teamLeadList here instead of leadList
                  style={{ width: "100%" }}
                  onChange={(leadId: any) => fetchTeamList(leadId)} // fetch team members for selected team lead
                  placeholder={"Select Team Lead"}
                  filterOption={filterOption}
                  onClear={() => {
                    setTeamFilter(null);
                    setIsTeamDropdownDisabled(true);
                  }}
                  allowClear
                />
              </Col>
            )}

          {["1", "2", "5"].includes(userData?.role) &&
            ![8, 9].includes(userData?.departmentId) && (
              <Col xl={6} sm={12} xs={24}>
                <Select
                  showSearch
                  options={teamList}
                  style={{ width: "100%" }}
                  onChange={(e: any) => onChangeData(e, "TEAM")}
                  placeholder={"Select Team"}
                  filterOption={filterOption}
                  onClear={() => setTeamFilter(null)}
                  allowClear
                  disabled={isTeamDropdownDisabled} // Disable or enable based on state
                />
              </Col>
            )}
        </Row>
      </div>
      {isLoading ? (
        <>
          {new Array(userData && userData?.role === "1" ? 3 : 1)
            .fill("")
            .map((_: any, index: number) => (
              <div style={{ marginTop: "30px" }} key={index}>
                <Skeleton styles={{ height: "20px", width: "100%" }} />
                <div
                  className="dashboard-container__leads--content"
                  style={{ marginTop: "30px" }}
                >
                  {new Array(5).fill("").map((_: any, i: number) => (
                    <Skeleton key={i} styles={{ height: "200px" }} />
                  ))}
                </div>
              </div>
            ))}
        </>
      ) : (
        <>
          {userData && ![8, 22, 23].includes(userData.departmentId) && (
            <>
              {leadsData && (
                <div className="dashboard-container__leads">
                  <div className="dashboard-container__leads--header">
                    <div className="dashboard-container__leads--header__title">
                      {userData.departmentId === 1 &&
                      (userData.role === "3" ||
                        userData.role === "2" ||
                        userData.role === "5") ? (
                        <p>Contacts</p>
                      ) : (
                        <p>Leads</p>
                      )}
                    </div>
                    <hr />
                  </div>
                  <div className="dashboard-container__leads--content">
                    {leadsData && Object.keys(leadsData).length > 0 && (
                      <>
                        {Object.keys(leadsData).map(
                          (key: any, index: number) => {
                            const findLead = cards.find((lead: any) =>
                              lead.keys.includes(key)
                            );
                            // if(findLead && leadsData[key] && leadsData[key] > 0){ // commented
                            if (findLead) {
                              const { title, Icon } = findLead;
                              return (
                                <div
                                  className="dashboard-container__leads--content__item"
                                  key={index}
                                  onClick={() =>
                                    handleCardClick(key, {
                                      title,
                                      count: leadsData[key],
                                    })
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <div>
                                    <div className="dashboard-container__leads--content__item--icon">
                                      <Icon size={45} />
                                    </div>
                                    <div className="dashboard-container__leads--content__item--text">
                                      <p>{leadsData[key]}</p>
                                      <p>{title}</p>
                                    </div>
                                  </div>
                                </div>
                              );
                            } else {
                              return <></>;
                            }
                          }
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
              {userData &&
                (userData.role === "1" ||
                  ([5].includes(userData.departmentId) &&
                    (userData.role === "2" ||
                      userData.role === "3" ||
                      userData.role === "5"))) &&
                paymentsData && (
                  <div className="dashboard-container__leads">
                    <div className="dashboard-container__leads--header">
                      <div className="dashboard-container__leads--header__title">
                        <p>Payments</p>
                      </div>
                      <hr />
                    </div>
                    <div className="dashboard-container__leads--content">
                      {paymentsData && Object.keys(paymentsData).length > 0 && (
                        <>
                          {Object.keys(paymentsData).map(
                            (key: any, index: number) => {
                              const findLead = cards.find((lead: any) =>
                                lead.keys.includes(key)
                              );
                              // if(findLead && paymentsData[key] && paymentsData[key] > 0){ // commented
                              if (findLead) {
                                const { title, Icon } = findLead;
                                return (
                                  <div
                                    className="dashboard-container__leads--content__item"
                                    key={index}
                                    onClick={() =>
                                      handleCardClick(key, {
                                        title,
                                        count: leadsData[key],
                                      })
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <div>
                                      <div className="dashboard-container__leads--content__item--icon">
                                        <Icon size={45} />
                                      </div>
                                      <div className="dashboard-container__leads--content__item--text">
                                        <p>
                                          <FaDollarSign />
                                          {new Intl.NumberFormat("en-US", {
                                            style: "decimal",
                                            minimumFractionDigits: 2,
                                          }).format(paymentsData[key])}
                                        </p>
                                        <p>{title}</p>
                                      </div>
                                    </div>
                                  </div>
                                );
                              } else {
                                return <></>;
                              }
                            }
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              {userData &&
                (userData.role === "1" ||
                  ([1].includes(userData.departmentId) &&
                    (userData.role === "2" || userData.role === "3"))) &&
                salesData && (
                  <div className="dashboard-container__leads">
                    <div className="dashboard-container__leads--header">
                      <div className="dashboard-container__leads--header__title">
                        <p>Sales Reports</p>
                      </div>
                      <hr />
                    </div>
                    <div className="dashboard-container__leads--content">
                      {/* <p>{JSON.stringify (salesData)}</p> */}
                      {salesData && Object.keys(salesData).length > 0 ? (
                        <>
                          {Object.keys(salesData).map(
                            (key: any, index: number) => {
                              const findLead = cards.find((lead: any) =>
                                lead.keys.includes(key)
                              );

                              if (findLead) {
                                const { title, Icon } = findLead;
                                return (
                                  <div
                                    className="dashboard-container__leads--content__item"
                                    key={index}
                                  >
                                    <div>
                                      <div className="dashboard-container__leads--content__item--icon">
                                        <Icon size={45} />
                                      </div>
                                      <div className="dashboard-container__leads--content__item--text">
                                        <p>{salesData[key]}</p>
                                        <p>{title}</p>
                                      </div>
                                    </div>
                                  </div>
                                );
                              } else {
                                return null; // Return null instead of empty fragment for clarity
                              }
                            }
                          )}
                        </>
                      ) : (
                        <p>No sales data available.</p>
                      )}
                    </div>
                  </div>
                )}
              {paymentsData === null &&
                leadsData === null &&
                salesData === null && (
                  <div>
                    <p>No Data to Display</p>
                  </div>
                )}
            </>
          )}
          {userData && [8].includes(userData.departmentId) && (
            <>
              {processData.length > 0 ? (
                <div className="dashboard-container__leadsContactPerson">
                  <div className="dashboard-container__leadsContactPerson--header">
                    <div className="dashboard-container__leadsContactPerson--header__title">
                      <p>Process</p>
                    </div>
                    <hr style={{ margin: 8 }} />
                  </div>
                  <div className="dashboard-container__leadsContactPerson--contentPerson">
                    {processData.map((process: any, i: number) => (
                      <div
                        className={`dashboard-container__leadsContactPerson--contentPerson__item ${
                          animationActive ? "active" : ""
                        }`}
                        key={process?.user_id}
                      >
                        <div>
                          <p className="dashboard-container__leadsContactPerson--contentPerson__item--title">
                            {process?.first_name + " " + process?.last_name}
                          </p>
                        </div>
                        <div className="dashboard-container__leadsContactPerson--contentPerson__item--text">
                          <p>
                            Leads : {process?.totalLeads} / Ref :{" "}
                            {process?.referals}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="dashboard-container__leadsContactPerson">
                  <div className="dashboard-container__leadsContactPerson--header">
                    <div className="dashboard-container__leadsContactPerson--header__title">
                      <p>Process</p>
                    </div>
                    <hr style={{ margin: 8 }} />
                  </div>
                  <p style={{ textAlign: "center", padding: 10 }}>
                    No Process Data to display
                  </p>
                </div>
              )}
              {financeData.length > 0 ? (
                <div className="dashboard-container__leadsContactPerson">
                  <div className="dashboard-container__leadsContactPerson--header">
                    <div className="dashboard-container__leadsContactPerson--header__title">
                      <p>Finance</p>
                    </div>
                    <hr style={{ margin: 8 }} />
                  </div>
                  <div className="dashboard-container__leadsContactPerson--contentPerson">
                    {financeData.map((process: any, i: number) => (
                      <div
                        className={`dashboard-container__leadsContactPerson--contentPerson__item ${
                          animationActive ? "active" : ""
                        }`}
                        key={process.user_id}
                      >
                        <div>
                          <p className="dashboard-container__leadsContactPerson--contentPerson__item--title">
                            {process?.first_name + " " + process?.last_name}
                          </p>
                        </div>
                        <div className="dashboard-container__leadsContactPerson--contentPerson__item--text">
                          <p>Leads : {process?.totalLeads}</p>
                          {/* <p>Referrals : {process?.referals}</p> */}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="dashboard-container__leadsContactPerson">
                  <div className="dashboard-container__leadsContactPerson--header">
                    <div className="dashboard-container__leadsContactPerson--header__title">
                      <p>Finance</p>
                    </div>
                    <hr style={{ margin: 8 }} />
                  </div>
                  <p style={{ textAlign: "center", padding: 10 }}>
                    No Finance Data to display
                  </p>
                </div>
              )}
            </>
          )}
          {userData &&
            userData &&
            (["1"].indexOf(userData.role) !== -1 ||
              ([22, 23].indexOf(userData.departmentId) !== -1 &&
                ["2", "3", "5"].indexOf(userData.role) !== -1)) &&
            ticketsData && (
              <div className="dashboard-container__leads">
                <div className="dashboard-container__leads--header">
                  <div className="dashboard-container__leads--header__title">
                    <p>Tickets</p>
                  </div>
                  <hr />
                </div>
                <div className="dashboard-container__leads--content">
                  {ticketsData && Object.keys(ticketsData).length > 0 && (
                    <>
                      {Object.keys(ticketsData).map(
                        (key: any, index: number) => {
                          const findLead = cards.find((lead: any) =>
                            lead.keys.includes(key)
                          );
                          // if(findLead && paymentsData[key] && paymentsData[key] > 0){ // commented
                          if (findLead) {
                            const { title, Icon, count } = findLead;

                            return (
                              <div
                                className="dashboard-container__leads--content__item"
                                key={index}
                              >
                                <div>
                                  <div className="dashboard-container__leads--content__item--icon">
                                    <Icon size={45} />
                                  </div>
                                  <div className="dashboard-container__leads--content__item--text">
                                    <p>{ticketsData[key]}</p>
                                    <p>{ticketsData[count]}</p>
                                    <p>{title}</p>
                                  </div>
                                </div>
                              </div>
                            );
                          } else {
                            return <></>;
                          }
                        }
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
        </>
      )}
      <Modal
        title={selectedLead?.info?.title || "Lead Details"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => setIsModalOpen(false)}
        centered
        width={700}
        footer={null}
      >
        {loading ? (
          <Spin tip="Loading lead details..." />
        ) : (
          <Table
            columns={columns}
            dataSource={leadDetails}
            rowKey="lead_id"
            pagination={{ pageSize: 5 }}
          />
        )}
      </Modal>
    </div>
  );
};

export default Dashboard;
